import { render } from "./Classes.vue?vue&type=template&id=166da06a&scoped=true&ts=true"
import script from "./Classes.vue?vue&type=script&lang=ts"
export * from "./Classes.vue?vue&type=script&lang=ts"

import "./Classes.vue?vue&type=style&index=0&id=166da06a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Edson\\Desktop\\work\\STUDOS PROD\\studiostvapp\\PlatformStudiosApp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-166da06a"]])

export default __exports__